/**
 * @generated SignedSource<<2387a5866f6445a03b6a42917044c95d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type CourseLayoutControl_Booking$data = {
  readonly startSlot: {
    readonly agenda?: {
      readonly facility: {
        readonly courseLayouts: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly code: string;
              readonly holeCount: HoleCount;
              readonly id: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      };
    };
    readonly permittedCourseLayouts?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly code: string;
          readonly holeCount: HoleCount;
          readonly id: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "CourseLayoutControl_Booking";
};
export type CourseLayoutControl_Booking$key = {
  readonly " $data"?: CourseLayoutControl_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"CourseLayoutControl_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CourseLayoutEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CourseLayout",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "holeCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CourseLayoutControl_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "memberVisible",
                  "value": true
                }
              ],
              "concreteType": "CourseLayoutConnection",
              "kind": "LinkedField",
              "name": "permittedCourseLayouts",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": "permittedCourseLayouts(memberVisible:true)"
            }
          ],
          "type": "TimeSlot",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Agenda",
              "kind": "LinkedField",
              "name": "agenda",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Facility",
                  "kind": "LinkedField",
                  "name": "facility",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CourseLayoutConnection",
                      "kind": "LinkedField",
                      "name": "courseLayouts",
                      "plural": false,
                      "selections": (v0/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "QueueSlot",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "f540de1883d3f6d1ccd8e752cf98f8a4";

export default node;
